import React from 'react';

export default {
  banner: {
    title: 'Gator Protect',
    description: 'Powered by Monarx AI',
    selectPlanLabel: 'Revisa la protección para el hospedaje web:',
    mainDomain: 'dominio principal:',
    proBadgeLabel: 'PRO',
    img: {
      alt: 'Snappy Monarx',
    },
  },
  activeTrialModal: {
    productTitle: 'Gator Protect',
    productSubtitle: 'Powered by Monarx AI',
    checklistItems: [
      'Eliminación automática de amenazas',
      'Evita la pérdida de datos y interrupciones en el sitio',
      'Te protege contra intrusiones, caídas y ataques',
      'Protección activa 24h con monitorización',
    ],
    termsPrefix: 'Leí y acepto los ',
    termsLink: 'Términos y Condiciones',
    trialActivation: {
      title: isAa => `Activa ahora y no pagues nada por ${isAa ? '1 año' : '30 días'}`,
      subtitle: price => `Después del período gratuito, suscríbete por solo ${price} al mes`,
      buttonLabel: 'Activar prueba gratis',
    },
    trialActive: {
      title: 'Continúa con la protección completa activa',
      subtitle: 'Después del período de prueba, la eliminación automática se desactivará.',
      message: daysLeft => (daysLeft >= 0 ? `Tu prueba termina en ${daysLeft} días.` : ''),
      buttonLabel: price => `Activar ahora por ${price}/mes`,
    },
  },
  activeProModal: {
    productTitle: 'Gator Protect',
    productSubtitle: 'Powered by Monarx AI',
    proBadgeLabel: 'PRO',
    checklistItems: [
      'Eliminación automática de amenazas',
      'Monitoreo continuo del sitio',
      'Atención especializada',
      'Protección activa 24h',
    ],
    termsPrefix: 'Leí y acepto los ',
    termsLink: 'Términos y Condiciones',
    title: 'Tu sitio puede estar vulnerable ahora',
    subtitle: 'Activa Gator Protect PRO y evita invasiones, caídas y pérdida de datos automáticamente.',
    buttonLabel: price => (price ? `Activar ahora por ${price}/mes` : 'Activar protección Pro'),
    turbo: {
      title: 'Protección completa para tus proyectos',
      subtitle: 'Garantiza monitoreo continuo y eliminación automática de amenazas.',
      checklistItems: [
        'Eliminación automática de amenazas',
        'Monitoreo continuo del sitio',
        'Atención especializada',
        'Protección activa 24h',
      ],
      termsPrefix: 'Leí y acepto los ',
      termsLink: 'Términos y Condiciones',
      buttonLabel: 'Activar protección Pro',
    },
  },
  summary: {
    threatsIdentified: 'Amenazas identificadas',
    threatsRemediated: 'Amenazas eliminadas',
    keepProtected: '¡Mantén tu sitio protegido!',
    keepProtectedDescription: 'No esperes a que se acabe el período de prueba de la protección completa. ¡Mantén la protección y quédate tranquilo!',
    keepProtectionActive: 'Mantener protección activa',
    protectionCard: {
      trialIsActive: {
        title: 'Continúa seguro sin interrupciones',
        description: 'Durante el período de prueba, Gator Protect Pro protege tu sitio contra amenazas reales de forma automática.',
        actions: [
          {
            key: 'activateProtectionPro',
            label: 'Mantener la protección activa',
            variant: 'primary',
          },
        ],
      },
      trialExpired: {
        title: 'Tu sitio está en riesgo y sin protección',
        description: 'Activa la protección completa: monitoreo continuo y eliminación automática de amenazas.',
        actions: [
          {
            key: 'activateProtectionPro',
            label: 'Reactivar protección completa',
            variant: 'primary',
          },
        ],
      },
      automaticProtectionAvailable: {
        title: 'Protección automática disponible',
        description: 'Activa ahora para eliminar automáticamente las amenazas identificadas.',
        activateProtectionPro: {
          key: 'activateProtectionPro',
          label: 'Activar protección Pro',
          variant: 'secondary',
        },
        activateTrial: {
          regular: {
            key: 'activateTrial',
            label: 'Probar 30 días gratis',
            variant: 'primary',
          },
          aa: {
            key: 'activateTrial',
            label: 'Probar 1 año gratis',
            variant: 'primary',
          },
        },
      },
      safeWithoutInterruption: {
        title: 'Sigue protegido sin interrupciones.',
        description: 'Durante el período de prueba, Gator Protect Pro ya protege tu sitio contra amenazas reales de forma automática.',
        actions: [
          {
            key: 'keepProtectionActive',
            label: 'Mantener protección activa',
            variant: 'primary',
          },
        ],
      },
      pendingInvoice: {
        title: '¡Tu protección está casi activa!',
        description: 'Finaliza el pago en la pestaña "Facturas" para activar el servicio.',
        goToInvoices: 'Ir a Facturas',
      },
      upgradeCycle: {
        getTitle: fromAnnualHosting => (
          fromAnnualHosting
            ? 'Garantiza protección por 3 años con descuento'
            : 'Garantiza protección durante todo el año con descuento'
        ),
        getDescriptionHtml: (percent, fromAnnualHosting) => (
          fromAnnualHosting
            ? `Cambia al plan trienal ahora y ahorra un <strong>${percent}% en la suscripción</strong>, equivalente a casi 2 meses gratis.`
            : `Cambia al plan anual ahora y ahorra un <strong>${percent}% en la suscripción</strong>, equivalente a casi 2 meses gratis.`
        ),
        getActionLabel: (percent, fromAnnualHosting) => (
          fromAnnualHosting
            ? `Suscribirse al plan trienal con ${percent}% de descuento`
            : `Suscribirse al plan anual con ${percent}% de descuento`
        ),
      },
    },
    upgradeCycleModal: {
      title: 'Garantiza protección durante todo el año con descuento',
      getSubtitleLeading: (cycleKey) => {
        if (cycleKey === 'monthly') {
          return 'En el plan mensual, pagas ';
        }
        if (cycleKey === 'triennially') {
          return 'En el plan trienal, ';
        }
        return 'En el plan anual, pagas ';
      },
      getSubtitleEmphasis: (cycleKey, percent) => {
        if (cycleKey === 'annually') {
          return `10 meses y permaneces protegido por 12, lo que representa un ${percent}% de descuento.`;
        }
        return `ahorra ${percent}% en la suscripción.`;
      },
      featureItems: [
        'Eliminación automática de amenazas',
        'Evita la pérdida de datos y interrupciones en el sitio',
        'Te protege contra intrusiones, caídas y ataques',
        'Protección activa 24h con monitorización',
      ],
      paymentCycleLabel: 'Ciclo de pago',
      selectCyclePlaceholder: 'Selecciona el ciclo',
      paymentCycleLabelMonthly: 'Mensual',
      paymentCycleLabelAnnual: 'Anual',
      paymentCycleLabelTriennial: 'Trienal',
      bestOptionSuffix: 'Mejor opción',
      getDiscountBadge: percent => `${percent}% off`,
      termsPrefix: 'Al activar, aceptas los ',
      termsLink: 'Términos y Condiciones',
      getCtaLabel: (cycleKey, formattedPrice) => {
        if (cycleKey === 'monthly') {
          return `Activar por ${formattedPrice}/mes`;
        }
        if (cycleKey === 'triennially') {
          return `Activar plan trienal por ${formattedPrice}`;
        }
        return `Activar por todo el año por ${formattedPrice}`;
      },
      refundNote: 'Hasta 30 días para reembolso',
      fromAnnualHosting: {
        title: 'Garantiza protección por 3 años con descuento',
        getSubtitleLeading: (cycleKey) => {
          if (cycleKey === 'monthly') {
            return 'En el plan mensual, pagas ';
          }
          return 'En el plan trienal, pagas ';
        },
        getSubtitleEmphasis: (cycleKey, percent) => {
          if (cycleKey === 'triennially') {
            return `ahorra ${percent}% en la suscripción y mantén la protección durante 3 años.`;
          }
          return `ahorra ${percent}% en la suscripción.`;
        },
        getCtaLabel: (cycleKey, formattedPrice) => {
          if (cycleKey === 'monthly') {
            return `Activar por ${formattedPrice}/mes`;
          }
          return `Activar plan trienal por ${formattedPrice}`;
        },
      },
    },
    automaticCleaningConsentModal: {
      title: 'Confirma la limpieza automática',
      description: 'Autorizo la eliminación de los archivos infectados y soy consciente de que el proceso puede causar pérdida de páginas o afectar el funcionamiento del sitio. No responsabilizo al soporte de HostGator por este proceso.',
      checkboxLabel: 'Leí y acepto',
      cancelButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Iniciar limpieza',
    },
    alerts: {
      fullProtectionActive: (
        <>
          <strong>Protección completa activa.</strong>
          {' ¡Tu sitio siempre seguro!'}
        </>
      ),
      cleaningInProgress: 'Tu limpieza está en curso. Espera hasta 24 h para realizar una nueva solicitud.',
      expiredProtection: 'Tu período de protección gratuita terminó. No dejes tu sitio vulnerable a virus y amenazas.',
      trialActive: daysLeft => (
        <>
          <strong>Tu período de prueba está activo.</strong>
          {' ¡Tu sitio está protegido por '}
          <strong>{`${daysLeft} días más!`}</strong>
        </>
      ),
      teamIntervention: {
        title: threatsNumber => `¡Tienes ${threatsNumber} amenazas que necesitan intervención de nuestro equipo!`,
        description: 'Para que el equipo continúe con el análisis y tratamiento, es necesario abrir un ticket.',
        buttonLabel: 'Abrir ticket',
      },
      teamInterventionResolved: {
        title: 'La amenaza fue analizada y eliminada por nuestro equipo',
        description: 'Tu hospedaje web sigue protegido con monitoreo automático de nuevas amenazas.',
        buttonLabel: 'Acceder al ticket',
      },
    },
    automaticRemovalToggle: {
      automaticRemovalLabel: isActive => (
        <>
          Remoción automática de amenazas activada.
          <strong>
            {isActive ? 'activa' : 'inactiva'}
          </strong>
        </>
      ),
      automaticRemovalTooltip: 'Cuando está activado, el sistema identifica y elimina automáticamente las amenazas de tu sitio.',
      lastVerification: ({ hour, day }) => (
        <>
          <strong>Monitoreo constante. última verificación:</strong>
          {` ${day} a las ${hour}`}
        </>
      ),
      noData: 'Esperando primer escaneo',
    },
  },
  threatsTable: {
    columns: {
      file: 'Archivo',
      threat: 'Amenaza',
      situation: 'Estado',
      detectedAt: 'Fecha de identificación',
    },
    situationTags: {
      quarantine: 'Amenaza no eliminada',
      remediated: 'Eliminada',
    },
    header: {
      exportButtonAriaLabel: 'Exportar',
      infoPlaceholder: 'Últimos 30 días',
    },
    tags: {
      quarantined: 'Amenaza no eliminada',
      remediated: 'Eliminada',
      cleaned: 'Limpia',
    },
  },
  activitiesChart: {
    title: 'Amenazas identificadas',
    titleInfoTooltip: 'Son archivos maliciosos que pueden amenazar la seguridad de tu sitio.',
    filter: {
      last30Days: 'Últimos 30 días',
    },
    compromisedFilesLabel: 'Archivos comprometidos',
    maliciousCodesLabel: 'Archivos maliciosos',
    emptyTitle: 'Ninguna actividad',
    emptyImageAlt: 'Ninguna actividad',
    emptyDescription: 'No se identificaron amenazas ni archivos sospechosos en los últimos 30 días.',
  },
  terms: {
    label: 'Leí y acepto los ',
    cta: 'términos y Condiciones',
  },
  acknowledgedModal: {
    title: {
      trial: ({ days }) => `Prueba gratis por ${days} días · Activo`,
      pro: ({ plan }) => `Protección Pro activa · incluida en tu plan ${plan}`,
    },
    secondTitle: {
      trial: ({ days }) => `Tu sitio está protegido automáticamente por ${days} días`,
      pro: 'Tu sitio ahora tiene protección automática',
    },
    description: {
      trial: (
        <>
          {'Activamos '}
          <strong>Gator Protect Pro</strong>
          {' en tu hosting para ayudar a mantener tu sitio seguro en el día a día.'}
        </>
      ),
      pro: (
        <>
          <strong>Gator Protect Pro</strong>
          {' ya está activo en tu hosting, ayudando a mantener tu sitio seguro en el día a día.'}
        </>
      ),
    },
    perksTitle: 'Tu sitio ahora cuenta con:',
    perks: [
      'Monitoreo continuo',
      'Eliminación automática de amenazas',
    ],
    cta: {
      trial: 'Quiero mantener la protección',
      pro: 'Acceder a Gator Protect',
    },
    additionalInfo: {
      trial: 'Al final de la prueba gratuita, decides si quieres continuar. Sin renovación automática y sin cargos.',
      pro: 'Administra o ajusta la protección de tu hosting en cualquier momento. Este recurso ya está incluido en tu plan Turbo, sin costo adicional.',
    },
  },
  detectedThreadsModal: {
    productTitle: 'Gator Protect',
    productSubtitle: 'Powered by Monarx AI',
    headline: 'Tu sitio necesita protección',
    bodyPrefix: 'Identificamos ',
    threatsBold: ({ count }) => (count === 1 ? '1 amenaza' : `${count} amenazas`),
    bodySuffixLine1: ' en tu sitio.',
    bodyLine2: 'Activa Gator Protect para mantener todo seguro.',
    primaryCta: 'Resolver amenazas ahora',
    shieldImageAlt: 'Gator Protect powered by Monarx',
  },
  noThreatsModal: {
    productTitle: 'Gator Protect',
    productSubtitle: 'Powered by Monarx AI',
    headlineLead: '+30.000 sitios',
    headlineRest: ' son hackeados cada día. Protege el tuyo',
    features: [
      {
        title: 'Detecta amenazas antes de que perjudiquen tu sitio',
        description: 'Monitoreo continuo de todos los archivos de tu sitio',
      },
      {
        title: 'Elimina virus automáticamente, sin que tengas que hacer nada',
        description: 'Eliminación inmediata de archivos infectados al activar',
      },
      {
        title: 'Protección activa 24 h al día',
        description: 'Tu sitio seguro todo el tiempo.',
      },
    ],
    primaryCta: 'Proteger mi sitio ahora',
    pricingFootnote: ({ price }) => `Desde ${price}/mes. Cancela cuando quieras`,
    shieldImageAlt: 'Gator Protect powered by Monarx',
  },
  insideProductDetail: {
    tag: 'PRO',
    title: 'Gator Protect',
    isNotTurbo: {
      isFree: {
        firstRow: 'Tu sitio está en riesgo. El monitoreo de tu sitio está activo, pero las amenazas no se eliminan automáticamente.',
        secondRow: days => (
          <>
            {'Activa la eliminación automática de amenazas. Realiza la '}
            <strong>
              {'prueba gratuita '}
              {days}
              {' días.'}
            </strong>
          </>
        ),
        cta: 'Acceder a la protección',
      },
    },
    isTurbo: {
      isFree: {
        firstRow: (
          <>
            {'Ya tienes acceso a la protección completa, '}
            <strong>sin costo adicional</strong>
            , pero la eliminación automática de amenazas aún no está activa.
          </>
        ),
        secondRow: 'Actívala ahora para mantener tu sitio siempre protegido.',
        cta: 'Acceder a la protección',
      },
      isPro: {
        withoutScan: {
          firstRow: (
            <>
              {'Tu sitio tiene protección completa en tu plan, pero la '}
              <strong>eliminación automática de amenazas</strong>
              {' aún no está activa.'}
            </>
          ),
          secondRow: 'Actívala ahora y no corras el riesgo de inestabilidad, cambios y bloqueos.',
          cta: 'Ir a la activación automática',
        },
        withScan: {
          firstRow: (
            <>
              {'Su '}
              <strong>sitio cuenta con protección completa:</strong>
              {' monitoreo continuo y eliminación automática de amenazas. Más seguridad y estabilidad.'}
            </>
          ),
          cta: 'Acceder a la protección',
          variant: 'secondary',
        },
      },
    },
    isTrial: {
      firstRow: (
        <>
          <strong>Protección completa activa (prueba gratuita)</strong>
          . Tus sitios cuentan con monitoreo continuo y eliminación automática de amenazas.
        </>
      ),
      secondRow: 'Aprovecha el período de prueba para conocer todos los beneficios.',
      cta: 'Acceder a los beneficios',
      variant: 'secondary',
    },
    isExpired: {
      firstRow: (
        <>
          <strong>Tu sitio está expuesto.</strong>
          {' La prueba gratuita terminó y la protección completa y la eliminación automática de amenazas ya no están activas.'}
        </>
      ),
      secondRow: 'Actívala, ya que un ataque puede dejar tu sitio fuera de línea.',
      cta: 'Acceder a la protección',
    },
  },
  migrateToGatorProtectModal: {
    title: '¡Protege tu sitio antes de que se convierta en un problema!',
    description: (
      <>
        {'Tu sitio puede ser invadido, caerse o exponer datos sin protección. '}
        <strong>Activa Gator Protect Pro y evita esto automáticamente.</strong>
      </>
    ),
    light: {
      title: 'Protección básica',
      list: [
        'Monitoreo de amenazas',
      ],
      cta: 'Continuar con Plan Light',
    },
    pro: {
      title: 'Protección completa y automática',
      list: [
        'Eliminación automática de amenazas',
        'Evita la pérdida de datos e interrupciones en el sitio',
        'Protege contra intrusiones, caídas y ataques',
        'Protección activa 24h con monitoreo',
      ],
      cta: price => `Activar ahora por ${price}/mes`,
      terms: 'Al activar, aceptas los ',
      termsCta: 'Términos y Condiciones',
    },
  },
  protectionCard: {
    aaClient: {
      notActivated: {
        title: '¡Felicitaciones! Has ganado 1 año gratis de Gator Protect Pro',
        description: 'Ative ahora para eliminar automáticamente las amenazas identificadas y mantener tu sitio siempre seguro.',
        actions: [
          { key: 'activateTrial', label: 'Activar 1 año gratis.', variant: 'primary' },
        ],
      },
      trialActive: {
        title: '¡Beneficio exclusivo para ti!',
        description: 'La protección completa y el monitoreo de tu sitio estarán activos todo el tiempo y totalmente gratis por un año. ¡Aprovecha!',
        actions: [
          { key: 'activateProtectionPro', label: 'Contratar Gator Protect', variant: 'primary' },
        ],
        banner: {
          boldPart: 'Tu período gratuito está activo.',
          regularPart: 'Tu sitio estará protegido hasta',
        },
      },
    },
  },
};
